import { EditSalesFunnelPageHeader } from '@pages/SalesFunnels/EditSalesFunnel/components/EditSalesFunnelPageHeader';

export { EditSalesFunnelPageHeader };
